// One extent around the given geometries, or null when none has an extent.
// Built on a copy, so the geometries' own extents are left unchanged.
export function extentOf(geometries) {
  const extents = geometries.map((geometry) => geometry?.extent).filter(Boolean);
  return extents.length ? extents.reduce((all, extent) => all.union(extent), extents[0].clone()) : null;
}
